var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 23,
    viewBox: "0 0 30 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2273 6.04537H21.8182V3.31809C21.8182 1.81809 20.5909 0.59082 19.0909 0.59082H2.72727C1.22727 0.59082 0 1.81809 0 3.31809V15.5908C0 17.0908 1.22727 18.3181 2.72727 18.3181C2.72727 20.5817 4.55455 22.409 6.81818 22.409C9.08182 22.409 10.9091 20.5817 10.9091 18.3181H19.0909C19.0909 20.5817 20.9182 22.409 23.1818 22.409C25.4455 22.409 27.2727 20.5817 27.2727 18.3181H28.6364C29.3864 18.3181 30 17.7045 30 16.9545V12.4135C30 11.8272 29.8091 11.2545 29.4545 10.7772L26.3182 6.59082C26.0591 6.24991 25.65 6.04537 25.2273 6.04537ZM6.81818 19.6817C6.06818 19.6817 5.45455 19.0681 5.45455 18.3181C5.45455 17.5681 6.06818 16.9545 6.81818 16.9545C7.56818 16.9545 8.18182 17.5681 8.18182 18.3181C8.18182 19.0681 7.56818 19.6817 6.81818 19.6817ZM25.2273 8.09082L27.9 11.4999H21.8182V8.09082H25.2273ZM23.1818 19.6817C22.4318 19.6817 21.8182 19.0681 21.8182 18.3181C21.8182 17.5681 22.4318 16.9545 23.1818 16.9545C23.9318 16.9545 24.5455 17.5681 24.5455 18.3181C24.5455 19.0681 23.9318 19.6817 23.1818 19.6817Z",
    fill: "#a890fe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDelivery);
export default __webpack_public_path__ + "static/media/ic_delivery.95bd458818621baf0ac34712311e1ac0.svg";
export { ForwardRef as ReactComponent };